
/* injects from baggage-loader */

'use strict';

/**
 * Constants to use in the file management filters module.
 */
const fileManagementFiltersConstant = {
	FINAL_DATE: 'Fecha final',
	INITIAL_DATE: 'Fecha inicial',
	INITIAL_DATE_HELP: 'La fecha mínima que puede seleccionar es de 60 días antes del día de hoy.',
	LIMIT_DATE: 60, // in days.
	REPORT_TYPE: 'Tipo de reporte',
	PROCESS_STATUS: 'Estado del proceso'
}

export default fileManagementFiltersConstant;



// WEBPACK FOOTER //
// ./src/app/core/components/fileManagementFilters/fileManagementFilters.constant.js